import React, { useEffect, useState } from 'react';
import { Switch } from 'react-router-dom';
import { hotjar } from 'react-hotjar';
import { useUserActions } from 'state';
import { ROUTES } from '_constants';

import { Route } from './Route';
import {
  PageAuth,
  PageMain,
  SingUp,
  Account,
  ChangePassword,
  ModelCatalog,
  Terms,
  Policy,
  StoneValidation,
  Upload,
  UploadMissions,
  EdgeUnits,
  Fields,
  StoneReview
} from 'pages';
import { ForgotPassword } from 'pages/ForgotPassword';

const { REACT_APP_HOTJAR_ID, REACT_APP_HOTJAR_SV } = process.env;

export const Routes = () => {
  const { getCurrentUser } = useUserActions();
  const [load, setLoad] = useState(true);

  useEffect(() => {
    getCurrentUser().finally(() => setLoad(false));
    window.addEventListener('focus', getCurrentUser);
    return () => window.removeEventListener('focus', getCurrentUser);
  }, [getCurrentUser]);

  useEffect(() => {
    if (REACT_APP_HOTJAR_ID && REACT_APP_HOTJAR_SV) {
      hotjar.initialize(REACT_APP_HOTJAR_ID, REACT_APP_HOTJAR_SV);
    }
  }, []);

  if (load) return null;

  return (
    <Switch>
      <Route path={ROUTES.UPLOAD} component={Upload} isPrivate />
      <Route path={ROUTES.UPLOAD_MISSIONS} component={UploadMissions} isPrivate />
      <Route path={ROUTES.MODELS} component={ModelCatalog} isPrivate />
      <Route path={ROUTES.TERMS} component={Terms} />
      <Route path={ROUTES.POLICY} component={Policy} />
      <Route path={ROUTES.ACCOUNT} component={Account} isPrivate />
      <Route path={ROUTES.SIGN_UP_CONFIRM} component={SingUp} />
      <Route path={ROUTES.SIGN_UP} component={SingUp} />
      <Route path={ROUTES.AUTH} component={PageAuth} />
      <Route path={ROUTES.FORGOT_PASSWORD} component={ForgotPassword} />
      <Route path={ROUTES.CONFIRM_PASSWORD} component={ChangePassword} />
      <Route isPrivate path={ROUTES.STONE_VALIDATION} component={StoneValidation} />
      <Route isPrivate path={ROUTES.RESET_PASSWORD} component={ChangePassword} />
      <Route isPrivate path={ROUTES.EDGE_UNITS} component={EdgeUnits} />
      <Route isPrivate path={ROUTES.FIELDS} component={Fields} />
      <Route isPrivate path={ROUTES.STONE_REVIEW} component={StoneReview} />
      <Route isPrivate path={ROUTES.ROOT} component={PageMain} />
    </Switch>
  );
};
